import BackLink from './BackLink.vue'; 
import Button from './Button.vue'; 
import Checklist from './Checklist.vue'; 
import Details from './Details.vue'; 
import InsetText from './InsetText.vue'; 
import Panel from './Panel.vue'; 
import PhaseBanner from './PhaseBanner.vue'; 
import Rationale from './Rationale.vue'; 
import Section from './Section.vue';
import WarningCallout from './WarningCallout.vue'; 
import WarningCalloutAlt from './WarningCalloutAlt.vue'; 
import Wysiwyg from './Wysiwyg.vue'; 

export default  {
	BackLink,
	Button,
	Checklist,
	Details,
	InsetText,
	Panel,
	PhaseBanner,
	Rationale,
	Section,
	WarningCallout,
	WarningCalloutAlt,
	Wysiwyg
};